import { defineComponent as o, openBlock as e, createElementBlock as a, normalizeClass as n, toDisplayString as i, createCommentVNode as r } from "vue";
import { _ as l } from "../../../_plugin-vue_export-helper-dad06003.js";
const s = o({
  name: "VAvatar",
  props: {
    imageSrc: {
      type: String,
      default: ""
    },
    imageDescrp: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: "orange",
      validator: (t) => ["orange", "grey-200"].includes(t)
    },
    initials: {
      type: String,
      default: "",
      validator: (t) => t === "" || t.length >= 2 && t.length <= 3
    }
  }
});
const c = {
  key: 0,
  class: "hobi-avatar__initials tw-font-obi-bold tw-text-lg tw-text-gray-800 tw-w-full tw-text-center tw-align-middle"
}, d = ["src", "alt"];
function g(t, p, f, u, _, m) {
  return e(), a("div", {
    class: n([
      "hobi-avatar tw-rounded-full tw-flex tw-object-cover tw-object-top",
      t.background === "orange" ? "tw-bg-orange" : t.background === "grey-200" ? "tw-bg-gray-200" : ""
    ])
  }, [
    t.initials ? (e(), a("p", c, i(t.initials), 1)) : r("", !0),
    t.imageSrc ? (e(), a("img", {
      key: 1,
      class: "hobi-avatar__img tw-rounded-full tw-flex tw-object-cover tw-object-top",
      src: t.imageSrc,
      alt: t.imageDescrp
    }, null, 8, d)) : r("", !0)
  ], 2);
}
const y = /* @__PURE__ */ l(s, [["render", g], ["__scopeId", "data-v-f00cbfcf"]]);
export {
  y as default
};
